export const formatAttendances = (list) => {
    const attendanceHist = [];
    const attendanceActive = [];
    let training = 0;
    let carry = 0;
    let exempt = 0;
    list.map((item) => {
        item.isActive ? attendanceActive.push(item) : attendanceHist.push(item);
        if (item.isActive) {
            if (item.hoursType === 'TRAINING')
                training += item.hoursLogged;
            if (item.hoursType === 'CARRYFORWARD')
                carry += item.hoursLogged;
            if (item.hoursType === 'EXEMPTION')
                exempt += item.hoursLogged;
        }
    });
    const total = training + carry + exempt;
    return {
        total,
        training,
        carry,
        exempt,
        attendanceActive,
        attendanceHist,
    };
};
export const initCreateModalState = {
    fields: {
        workshopName: {
            value: '',
            isValid: true,
            focus: false,
            validate: false,
            required: true,
        },
        startDate: {
            value: '',
            isValid: true,
            focus: false,
            validate: true,
            required: true,
            message: '',
        },
        endDate: {
            value: '',
            isValid: true,
            focus: false,
            validate: true,
            required: true,
            message: '',
        },
        hours: {
            value: 0,
            isValid: true,
            focus: false,
            validate: false,
            required: true,
        },
        comments: { value: '', isValid: true, required: false },
    },
};
export const initEditModalState = {
    fields: {
        id: {
            value: '',
        },
        workshopName: {
            value: '',
            isValid: true,
            focus: false,
            validate: true,
            required: true,
            message: '',
        },
        startDate: {
            value: '',
            isValid: true,
            focus: false,
            validate: true,
            required: true,
            message: '',
        },
        endDate: {
            value: '',
            isValid: true,
            focus: false,
            validate: true,
            required: true,
            message: '',
        },
        hoursLogged: {
            value: 0,
            isValid: true,
            focus: false,
            validate: false,
            required: true,
        },
        comments: { value: '', isValid: true, required: false },
    },
};
